import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

// redux
import { setFilter } from "redux/slices/notifications/notificationsSlice";

const options = [
  { value: "MANAGER_ALARM_SCHEDULE", label: "스케줄" },
  { value: "MANAGER_ALARM_MEMBER", label: "회원" },
  { value: "MANAGER_ALARM_SALES", label: "매출" },
  { value: "MANAGER_ALARM_COACH", label: "임직원" },
  { value: "MANAGER_ALARM_CEO_REPORT", label: "CEO 리포트" },
  { value: "MANAGER_ALARM_SMS_NOTICE", label: "SMS ∙ 공지" },
];

const TypeFilter = ({ onClick }) => {
  const { filter } = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const target = e.currentTarget;
    const value = target.value;
    const index = filter.indexOf(value);
    const updatedList = [...filter];

    if (value && value !== "all") {
      // not inside filter && not 전체
      if (index === -1) {
        if (target.checked && filter.length < options.length) {
          if (filter.length === options.length - 1) {
            dispatch(setFilter([]));
            onClick({ filter: [] });
            return;
          }
          updatedList.push(value);
        }
      }
      // already inside filter
      else {
        updatedList.splice(index, 1);
      }
      dispatch(setFilter([...updatedList]));
      onClick({ filter: [...updatedList] });
    } else {
      if (filter.length) {
        dispatch(setFilter([]));
        onClick({ filter: [] });
      } else return;
    }
  };

  const renderOptions = () => {
    const list = options.map((item, index) => {
      const isChecked = filter.indexOf(item.value) > -1;
      return (
        <Option key={index} checked={isChecked}>
          <input
            name="filter"
            type="checkbox"
            checked={isChecked}
            value={item.value}
            hidden
            onChange={handleChange}
          />
          <span htmlFor="filter">{item.label}</span>
        </Option>
      );
    });

    return (
      <>
        <Option checked={!filter.length}>
          <input
            name="all"
            type="checkbox"
            checked={!filter.length}
            value={"all"}
            hidden
            onChange={handleChange}
          />
          <span htmlFor="all">{"전체"}</span>
        </Option>
        {list}
      </>
    );
  };

  return (
    <OuterWrapper>
      <InnerWrapper>
        <Wrapper>{renderOptions()}</Wrapper>
      </InnerWrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 8;
`;

const InnerWrapper = styled.div`
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  max-width: 768px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 12px 20px;
  background: white;
  overflow: hidden;
  overflow-x: scroll;

  label:not(:last-child) {
    margin-right: 8px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const Option = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #f2f2f4;
  border-radius: 16px;
  padding: 6px 16px;
  background-color: ${(props) => (props.checked ? "#004FEC" : "inherit")};

  span {
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => (props.checked ? "white" : "#515458")};
    font-weight: ${(props) => (props.checked ? 600 : "normal")};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export default TypeFilter;
